"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExchangeRequest = void 0;
var ExchangeRequest = /** @class */ (function () {
    function ExchangeRequest() {
    }
    return ExchangeRequest;
}());
exports.ExchangeRequest = ExchangeRequest;
;
//# sourceMappingURL=exchange.request.js.map